module.exports = __webpack_public_path__ + "img/frame (96).d896b476.jpg";